export function initFichaProyecto() {
  const modal = document.querySelector('.video-modal');
  if (!modal) return;

  const backdrop = modal.querySelector('.video-modal__backdrop');
  const closeBtn = modal.querySelector('.video-modal__close');
  const iframe = modal.querySelector('.video-modal__iframe');
  const thumbs = document.querySelectorAll('.video-thumb');

  const open = (videoId) => {
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  };

  const close = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    iframe.src = '';
    document.body.style.overflow = '';
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => open(thumb.dataset.videoId));
  });

  backdrop.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
}
